/* eslint-disable no-magic-numbers */
import * as yup from 'yup';
import { errorTexts } from '@features/errors';

export const wagonTypeSchema = yup.object().shape({
  name: yup.string().required(errorTexts.required()),
});
